import { render, staticRenderFns } from "./HelpTerm.vue?vue&type=template&id=33fc44ab"
import script from "./HelpTerm.vue?vue&type=script&setup=true&lang=ts"
export * from "./HelpTerm.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports